import styled, { css } from 'styled-components';
import type React from 'react';

export type Props = {
  $hasError?: boolean,
  $isHeaderVariant?: boolean,
  $isAutoWidth?: boolean,
} & React.SelectHTMLAttributes<HTMLSelectElement>;

const Select = styled.select<Props>`
  box-sizing: border-box;
  height: ${({ $isHeaderVariant }) => ($isHeaderVariant ? 'var(--input-height-big)' : 'var(--input-height-default)')};
  width: ${({ $isAutoWidth }) => ($isAutoWidth ? 'auto' : '100%')};
  padding: 0 6px;
  margin: 0;
  font-size: ${({ $isHeaderVariant }) => ($isHeaderVariant ? 'var(--font-size-h1)' : 'var(--font-size-default)')};
  color: var(--color-text-default);
  background: var(--color-input-background);
  border: var(--border-input);
  border-radius: var(--border-radius-input);

  &::placeholder {
    color: var(--color-input-placeholder);
    opacity: 1;
  }

  &:focus {
    outline: var(--outline-input-focus);
  }

  &[disabled] {
    background-color: var(--color-background-disabled);
    border-color: var(--color-input-border-disabled);
  }

  ${({ $hasError }) => $hasError && css`
    &:not(:focus) {
      color: var(--color-error);
      border-color: var(--color-error);
    }
  `}

  &:required:invalid {
    color: var(--color-input-placeholder);
  }

  option[value=""][disabled] {
    display: none;
  }

  option {
    color: var(--color-text-default);
  }
`;

export default Select;
